import React, { useState, useEffect } from "react";
import {
  Rating,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { FaStar } from "react-icons/fa6";

const RatingComponent = ({
  orderId,
  currentRating,
  onSubmitRating,
  open,
  onClose,
  direction = "ltr",
  t
}) => {
  const [pendingRating, setPendingRating] = useState(0);
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    if (!open) {
      setPendingRating(0); // Reset pending rating when dialog is closed
    }
  }, [open]);

  const handleRatingChange = (newRating) => {
    if (currentRating) return; // Prevent updates if already rated
    setPendingRating(newRating);
  };

  const handleConfirmRating = () => {
    onSubmitRating(orderId, pendingRating);
    setSuccessMessage(true);
    setTimeout(() => setSuccessMessage(false), 3000); // Hide success message after 3 seconds
    if (onClose) onClose(); // Close dialog via parent control
  };

  const handleCancelRating = () => {
    setPendingRating(0);
    onClose();
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Dialog open={open} onClose={handleCancelRating} maxWidth="xs" fullWidth>
        <Box
          sx={{
            backgroundColor: "var(--secondary-color)",
            borderRadius: "16px",
            padding: "16px",
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: "var(--primary-color-light)",
              paddingBottom: 0,
              marginBottom: "16px", // Add margin to space out elements
            }}
          >
            {/* Close Icon (Top-right) */}
            <IconButton
              onClick={handleCancelRating}
              sx={{
                color: "var(--primary-color-light)",
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <Close />
            </IconButton>

            {/* Centered Star Icon */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgb(204 222 239 / 50%)",
                borderRadius: "50%",
                width: "60px", // Increase size
                height: "60px", // Increase size
                margin: "0 auto",
                color: "var(--primary-color)",
              }}
            >
              <FaStar style={{ fontSize: "36px" }} /> {/* Increase the size of the star */}
            </Box>
          </DialogTitle>

          <DialogContent sx={{ textAlign: "center", color: "var(--primary-color)" }}>
            {/* Header */}
            <Typography variant="h6" fontWeight="600" gutterBottom>
              {t.ratingTitle}
            </Typography>

            {/* Description */}
            <Typography variant="body2" sx={{ color: "#a5a3a3" }} gutterBottom>
            {t.ratingDescription}
            </Typography>

            {/* Rating Stars */}
            <Rating
              name={`dialog-rating-${orderId}`}
              value={pendingRating}
              onChange={(event, newValue) => handleRatingChange(newValue)}
              precision={0.5}
              sx={{ color: "var(--primary-color)", fontSize: "40px", direction: "ltr" }} // Make the stars larger
            />
          </DialogContent>

          {/* Action Buttons */}
          <DialogActions sx={{ justifyContent: "center", marginTop: "16px" }}>
            <Button
              onClick={handleConfirmRating}
              disabled={pendingRating === 0}
              sx={{
                backgroundColor:
                  pendingRating === 0 ? "rgba(255, 255, 255, 0.3)" : "var(--primary-color)",
                color: "var(--secondary-color)",
                "&:hover": {
                  backgroundColor:
                    pendingRating === 0 ? "rgba(255, 255, 255, 0.3)" : "var(--primary-color-dark)",
                },
                borderRadius: "8px",
                padding: "8px 24px",
              }}
            >
              {pendingRating === 0 ? t.submit : t.submit}            </Button>
          </DialogActions>
        </Box>
      </Dialog>


    </Box>
  );
};

export default RatingComponent;
